document.addEventListener('DOMContentLoaded', () => {
  if(screen.width >= 768){
    moveElementAfter('.product__info-container .accordion-container', 'media-gallery')
  }
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};


document.addEventListener("teeinblue-event-component-injected", function () {
  const bannerContainer = document.createElement("div");
  bannerContainer.className = "teein-banner-container";

  const img1 = document.createElement("img");
  img1.className = "teein-img1";
  img1.src =
    "https://cdn.shopify.com/s/files/1/0835/3624/9097/files/Design_ohne_Titel_-_2025-02-18T091203.646.svg?v=1739866493";
  img1.alt = "Image 1";
  img1.style.width = "25px";
  img1.style.paddingRight = "7px";
  img1.style.marginBottom = "14px";
  img1.style.marginTop = "14px";

  const textDiv = document.createElement("div");
  textDiv.className = "teein-content";
  textDiv.textContent = "Produkt personalisieren";
  textDiv.style.paddingleft = "100px";

  // Tạo phần tử img thứ hai
  const img2 = document.createElement("img");
  img2.className = "teein-img2";
  img2.src =
    "https://cdn.shopify.com/s/files/1/0835/3624/9097/files/Kopie_von_Kein_Titel_3000_x_2000_px_2.svg?v=1739866954";
  img2.alt = "Image 2";
  img2.style.width = "49px";
  img2.style.paddingLeft = "1px";

  bannerContainer.appendChild(img1);
  bannerContainer.appendChild(textDiv);
  // bannerContainer.appendChild(img2);

  // Thêm div chính vào body của trang web
  document.querySelector("#teeFormInputs").appendChild(bannerContainer);
});

// document.addEventListener("teeinblue-event-component-injected", function () {
//   const elementToMove = document.createElement("div");
//   elementToMove.className = "tee-sizeGuideButton";
//   elementToMove.textContent = "🖼️ Größenansicht";
//   const insertAfterElement = document.querySelector(
//     ".tee-option--size .tee-option__title"
//   );
//   if (elementToMove && insertAfterElement) {
//     insertAfterElement.appendChild(elementToMove);
//   }
//   document
//     .querySelector(".tee-sizeGuideButton")
//     .addEventListener("click", function () {
//       document.getElementById("sizeGuideModal").style.display = "block";
//     });
// });
// document.addEventListener("teeinblue-event-component-injected", function () {
//   const elementToMove2 = document.createElement("span");
//   elementToMove2.className = "tee-photoGuideButton";
//   elementToMove2.textContent = "📷 Foto Anleitung";
//   const insertAfterElement2 = document.querySelector(
//     "#tee-field--layer-243710 > label "
//   );
//   if (elementToMove2 && insertAfterElement2) {
//     insertAfterElement2.appendChild(elementToMove2);
//   }
//   document
//     .querySelector(".tee-photoGuideButton")
//     .addEventListener("click", function () {
//       document.getElementById("photoGuideModal").style.display = "block";
//     });
// });

document.addEventListener("teeinblue-event-after-cart-added", () => {
  setTimeout(function () {
    SLIDECART_UPDATE();
    SLIDECART_OPEN();
  }, 1000);
});

document.addEventListener("teeinblue-event-after-cart-added", () => {
  console.log("test");
  var request = new XMLHttpRequest();
  request.open("GET", "/cart.js", true);
  request.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartCount = document.querySelectorAll("#cart-icon-bubble");
      console.log(cartCount.length, itemCount > 0);
      if (cartCount.length && itemCount > 0) {
        cartCount.forEach(function (cart) {
          cart.innerHTML =
            '<a href="/cart" class="header__icon header__icon--cart link focus-inset" id="cart-icon-bubble"><svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg><span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">' +
            itemCount +
            '</span><span class="visually-hidden">' +
            itemCount +
            " items</span></div>";
        });
      } else {
        cartCount.forEach(function (cart) {
          cart.innerHTML =
            '<a href="/cart" class="header__icon header__icon--cart link focus-inset" id="cart-icon-bubble"><svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"></path></svg><span class="visually-hidden">Cart</span>';
        });
      }
    }
  };
  request.send();
});
document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    ".money.theme-money.price.tee-price--current"
  );
  const insertAfterElement = document.querySelector(
    ".tee-price--compare-wrapper.tee-price--regular-wrapper"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }

  const elementToMove3 = document.querySelector(".tee-price-hook--after");
  const insertAfterElement3 = document.querySelector(
    "span.money.theme-money.price.tee-price--current"
  );
  if (elementToMove3 && insertAfterElement3) {
    insertAfterElement3.after(elementToMove3);
  }

  document
    .querySelectorAll(".money.theme-money.price")
    .forEach(function (element) {
      element.innerHTML = element.innerHTML.replace(" EUR", "");
    });
});
setInterval(function () {
  /*
   *
   * TEEINBLUE PRICE
   *
   */
  if (
    document.querySelector(".tee-price--saving") &&
    document
      .querySelector(".tee-price--saving")
      .querySelectorAll(".money.theme-money.price")
  ) {
    var compare_price = document.querySelector(
      ".money.theme-money.price.tee-price--compare"
    ).innerHTML;
    var regular_price = document.querySelector(
      ".money.tee-price--current"
    ).innerHTML;
    compare_price = compare_price.replace(/[^\d.]/g, "");
    regular_price = regular_price.replace(/[^\d.]/g, "");
    var precent =
      ((parseFloat(compare_price) - parseFloat(regular_price)) /
        parseFloat(compare_price)) *
      100;
    document
      .querySelector(".tee-price--saving")
      .querySelectorAll(".money.theme-money.price")[0].innerHTML =
      "Spare heute -" + parseInt(precent) + "%" + " in unserem Black November Sale";
  }
  /*
   *
   * THEME PRICE
   *
   */
  if (
    document.querySelector(
      ".price--on-sale .price-item--regular s, .price--on-sale s.price-item--regular"
    ) &&
    document.querySelector(".price--on-sale .price-item--sale.price-item--last")
  ) {
    const themeCompare = document.querySelector(
      ".price-item--regular s, s.price-item--regular"
    );
    const themeCurrent = document.querySelector(
      ".price-item--sale.price-item--last"
    );
    comparePrice = themeCompare.textContent
      .replace(/[^\d,]/g, "")
      .replace(",", ".");
    regularPrice = themeCurrent.textContent
      .replace(/[^\d,]/g, "")
      .replace(",", ".");
    const percent =
      ((parseFloat(comparePrice) - parseFloat(regularPrice)) /
        parseFloat(comparePrice)) *
      100;
    let badge = document.querySelector(".price__badge-sale");
    if (badge) {
      badge.innerText = `Spare heute -${parseInt(
        percent
      )}% in unserem Black November Sale`;
    } else {
      const newBadge = document.createElement("span");
      newBadge.className = "badge price__badge-sale color-scheme-3";
      newBadge.innerText = `Spare heute -${parseInt(
        percent
      )}% in unserem Black November Sale`;
      const container = document.querySelector(".price.price--on-sale");
      if (container) container.appendChild(newBadge);
    }
  }
}, 100);

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutations) => {
    const slideCart = document.querySelector(".slidecarthq");

    if (slideCart && slideCart.classList.contains("open")) {
      document.querySelectorAll(".properties-key-value-key").forEach((el) => {
        switch (el.textContent.trim()) {
          case "Available Product":
            el.textContent = "Produkt";
            break;
          case "Size":
            el.textContent = "Größe";
            break;
          case "Color":
            el.textContent = "Farbe";
            break;
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
});


/* Jason - 09172025 - START */

document.addEventListener('teeinblue-event-component-injected', function() {
  const checkElementRendered = setInterval(() => {
    const kiwiSizingChart = document.querySelector('.ks-chart-container')
    const sizeOptionTitle = document.querySelector('.tee-variants');
    if (kiwiSizingChart && sizeOptionTitle) {
        clearInterval(checkElementRendered);
        sizeOptionTitle.before(kiwiSizingChart);
    }
  }, 500);
});

/* Jason - 09172025 */

/* Jason - 11062025 - START */
document.addEventListener("DOMContentLoaded", function () {
  const mediaGallery = document.querySelector("media-gallery");
  if (mediaGallery) {
    const observer2 = new MutationObserver(() => {
      const teeGallery = mediaGallery.querySelector("#tee-gallery");
      if (teeGallery) {
        window.dispatchEvent(new Event("resize"));
        observer2.disconnect();
      }
    });
    observer2.observe(mediaGallery, { 
      childList: true, 
      subtree: true 
    });
  }
})
async function fixCustomizationImages() {
  try {
    const response = await fetch('/cart.json');
    const cart = await response.json();
    document.querySelectorAll('.slidecarthq .item').forEach(itemEl => {
      const lineItemKey = itemEl.getAttribute('data-line-item-key');
      if (!lineItemKey) return;

      const cartItem = cart.items.find(i => i.key === lineItemKey);
      if (!cartItem) return;

      const correctImg = cartItem.properties?._customization_image;
      if (!correctImg) return;

      const imgEl = itemEl.querySelector('.tee-cart-thumbnail__img');
      if (!imgEl) return;

      if (imgEl.src !== correctImg) {
        imgEl.src = correctImg;
        imgEl.alt = `Customization ${cartItem.properties?._customization_id || ''}`;
      }
    });
  } catch (err) {
    console.error('Error fetch /cart.json:', err);
  }
}
window.SLIDECART_OPENED = function() {
  fixCustomizationImages();
  setTimeout(() => {
    fixCustomizationImages(); 
  }, 10000)
}
/* Jason - 11062025 - END */